import script from "./Likes.vue?vue&type=script&setup=true&lang=js"
export * from "./Likes.vue?vue&type=script&setup=true&lang=js"

import "./Likes.vue?vue&type=style&index=0&id=d21b83ee&lang=css"

const __exports__ = script;

export default __exports__